<template>
<div class="auth flex flex-wrap min-h-screen">
    <alert v-model="notify.show" :errorType="notify.type" :message="notify.message" />
    <router-link to="/">
        <img class="inline h-24 p-4 fixed" :src="tenantLogo" alt="" />
    </router-link>
    <div :style="'background: linear-gradient(89.81deg, #111111 0.05%, rgba(46, 58, 110, 0.55) 41.25%), url('+ loginPageBanner+ ') no-repeat center center ; background-size: cover;'" class="w-full md:w-1/2 md:flex hidden items-center justify-center text-center text-black p-6">
        <!-- <div class="mx-4 md:mx-16">
        <span class="welcome-back block">Welcome Back</span>
        <span class="welcome-mini block">Let's get you in the game</span>
      </div> -->
    </div>
    <div class="w-full md:w-1/2 text-white  flex items-center justify-center text-center">
        <div class="form w-full md:w-4/5 mx-4 md:mx-auto">
            <p class="purple-bg mx-auto uppercase py-3">Sign Up</p>
            <p class="main my-2">Create an account</p>
            <p class="mini">Build skills for today, tomorrow, and beyond.</p>
            <p class="mini">Education to future-proof your career.</p>
            <div class="mx-4 md:mx-12">
                <div class="my-6">
                    <input v-model="data.email" class="shadow appearance-none border rounded w-full py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="email" type="email" placeholder="Email" />
                    <label class="mt-3 mb-3 ml-3" style="color: red" v-if="errors">{{errors.email}}</label>
                </div>
                <div class="my-6">
                    <input v-model="data.first_name" class="shadow appearance-none border rounded w-full py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="first_name" type="text" placeholder="First Name" />
                    <label class="mt-3  mb-3 ml-3" style="color: red" v-if="errors">{{errors.first_name}}</label>

                </div>
                <div class="my-6">
                    <input v-model="data.last_name" class="shadow appearance-none border rounded w-full py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="last_name" type="text" placeholder="Last Name" />
                    <label class="mt-3 mb-3 ml-3" style="color: red" v-if="errors">{{errors.last_name}}</label>

                </div>
                <!--          <div class="my-6">-->
                <!--            <input-->
                <!--              v-model="data.last_name"-->
                <!--              class="shadow appearance-none border rounded w-full py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"-->
                <!--              id="first_name"-->
                <!--              type="text"-->
                <!--              placeholder="Last Name"-->
                <!--            />-->
                <!--          </div>-->

                <div class="my-6">
                    <input class="shadow appearance-none border rounded w-full py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="password" placeholder="Password" v-model="data.password" />

                </div>

                <div class="my-6">
                    <input class="shadow appearance-none border rounded w-full py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="confirm_password" type="password" placeholder="Confirm Password" v-model="data.password_confirmation" />
                </div>

                <p class="mini" v-if="$route.query.from !== 'cart'">
                    By clicking Sign Up, you agree to our Terms of Use and our Privacy
                    Policy
                </p>
                <p class="mini" v-else>
                    Signup to complete your checkout
                </p>

                <button @click.prevent="submit" class="purple-bg text-white w-full py-2 px-4 mt-4 mb-2 rounded uppercase">
                    Create Account
                </button>
            </div>
            <div class="flex flex-wrap justify-center mb-4">
                <p v-if="$route.query.from !== 'cart'" class=" mt-4 forgot-password">
                    <router-link to="/tenant/login">Login here?</router-link>
                </p>
                <p v-else class=" mt-4 forgot-password">
                    <router-link to="/tenant/login?from=cart">Login here?</router-link>
                </p>
            </div>
            <div class="flex flex-wrap justify-center mb-4"></div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters
} from "vuex";
import SettingsMixin from "@/mixins/SettingsMixin";
export default {
    mixins: [SettingsMixin],
    data() {
        return {
            data: {},
            loading: false,
            errors: null,
            notify: {
                type: null,
                show: false,
                message: "",
            },
        };
    },
    components: {
        Alert: () => import("@/components/admin/alert"),
    },
    mounted() {},

    methods: {
        ...mapActions(["register"]),
        async submit() {
            if (!this.data.email) {
                this.handleNotify({
                    type: "error",
                    message: "You need to enter your Email",
                });
                return;
            }
            if (!this.data.password) {
                this.handleNotify({
                    type: "error",
                    message: "You need to enter your Password",
                });
                return;
            }
            if (this.data.password !== this.data.password_confirmation) {
                this.handleNotify({
                    type: "error",
                    message: "Password Confirmation Does not match",
                });
                return;
            }
            this.loading = true;
            let res = await this.register(this.data);
            if (res.status == 200 || res.status == 201) {
                this.loading = false;
                this.$router.push("/learner/login?success=true")
            } else {
                this.loading = false;
                this.handleNotify({
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title :
                        "An error occured",
                });
                this.errors = res.data.errors[0].source
                // this.$toasted.error(res.data.message).goAway(2500);
            }
        },
        handleNotify(payload) {
            this.notify.show = true;
            this.notify.type = payload.type;
            this.notify.message = payload.message;
        },
    },
};
</script>

<style scoped>
.auth {
    background: #102767;
}

.form {
    background: #2e3a6e;
}

.purple-bg {
    background: #5e6da8;
    color: white;
}

.main {
    font-size: 24px;
    line-height: 48px;
}

.mini {
    font-size: 14px;
    line-height: 22px;
    margin: 5px auto;
}
</style>
